import React, {Component} from 'react';
import {findDOMNode} from 'react-dom';

import {reverseParseTextView} from './createRender';
import './index.less';
import Footer from '../Footer';
const $ = require('$');
const MathQuill = require('MathQuill');
const MQ = MathQuill.getInterface(2);

class Exercise extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: true
        };
    }

    componentDidMount() {
    		this.MQLoad()
    		let originData = this.props.data;
        let data = reverseParseTextView(originData);
    		this.toggleAnswer(true,data.answer)
    }

    componentDidUpdate() {
        this.MQLoad();
    }

    createHtml = str => ({__html: str ? str : `&nbsp;`});

    MQLoad = () => {
        $('.mathquill-embedded-latex', this.viewer).removeAttr('style').each(function (index, item) {
            // 然而, 我们这里并不是可编辑的
            MQ.StaticMath(item);
        });
    };

    toggleAnswer = (val,answer) => {
        this.setState({visible: val});
        const blanks = $(findDOMNode(this)).find(`span[data-id]`);
        const addDecimalPoints = $(findDOMNode(this)).find(`span.add_decimal-point`);
        const decimalPoints = $(findDOMNode(this)).find(`span.decimal-point`);
        const vertivalWrapDom = $(findDOMNode(this)).find(`.math_shushi`);
        if (val) {
            blanks.each(function() {
                const id = $(this).attr('data-id');
                $(this).html(answer[id].split('|')[0]);
            });
            addDecimalPoints.each(function() {
                $(this).addClass('active');
            })
            decimalPoints.each(function() {
                $(this).addClass('active');
            })
            vertivalWrapDom.addClass('active');
        } else {
            blanks.html('');
            addDecimalPoints.each(function() {
                $(this).removeClass('active');
            })
            decimalPoints.each(function() {
                $(this).removeClass('active');
            })
            vertivalWrapDom.removeClass('active');
        }
    };

    render() {
        const {visible} = this.state;
        const {num} = this.props;
        let originData = this.props.data;
        let data = reverseParseTextView(originData);
        return (
            <div className="box-exercise" ref={(el) => this.viewer = el}>
                <div className="exercise-content">
                    <div className="exercise-num"><p className="math_text">{`${num + 1}.`}</p></div>
                    <div className="exercise-con" dangerouslySetInnerHTML={this.createHtml(data.stem)}/>
                </div>
                <div className="exercise-footer">
                    {
                        visible &&
                        <div className="footer-hide relative">
                            {
                                data.explain && <div>
                                    <div className="inline-block"><span style={{fontSize: 14}}>答案解析：</span></div>
                                    <div className="inline-block">
                                        <span style={{fontSize: 14}} dangerouslySetInnerHTML={this.createHtml(data.explain)}/>
                                    </div>
                                </div>
                            }
                        </div>
                    }

                    <div className="footer-show relative">
                        <Footer {...this.props} obj={originData} subject={this.props.data.subject}>
                            {
                                this.props.canShowAnswer ?
                                    <button
                                        className="question-btn"
                                        onClick={() => this.toggleAnswer(!visible,data.answer)}>
                                        {!visible ? '显示答案' : '隐藏答案'}
                                    </button> : null
                            }

                        </Footer>
                    </div>
                </div>
            </div>
        )
    }
}

export default Exercise;


// WEBPACK FOOTER //
// ./src/entry_question_editor/question/exercise/verticalSecond/view.js